<template>
  <settings-group-item :label="label" :description="description">
    <div class="d-flex align-center fill-height">
      <votes-required-input v-model="model" :disabled="disabled" />
    </div>
  </settings-group-item>
</template>

<script>
import SettingsGroupItem from './SettingsGroupItem';
import VotesRequiredInput from './VotesRequiredInput';

export default {
  name: 'ConsensusRequiredVotesSetting',
  components: { SettingsGroupItem, VotesRequiredInput },
  props: {
    value: {
      type: Number,
      default: 2,
    },
    label: {
      type: String,
      default: 'Votes Required for Consensus',
    },
    description: {
      type: String,
      default: 'How many reviewers must vote on a reference',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
